<template>
    <div class="editIcon">
        <el-dialog title="选择图标" :visible.sync="dialogFormVisible">
            <p class="localChoice">电脑本地选择</p>
            <div class="btnBox">
                <el-button type="primary"><label for="upload">本地上传</label></el-button>
                <span class="iconTips">仅支持 .png格式，不大于100KB（系统默认：未选中图标颜色#999999）</span>
            </div>
            <input type="file" id="upload" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event,2)">
            <div class="iconLibrary">
                <p>从图标库选择</p>
                <div class="iconBox">
                    <div @click="choiceIcon(item, index)" :class="{'iconItem': true, 'select': selectedIconIndex === index}" v-for="(item, index) in iconData" :key="index">
                        <img v-lazy="item" alt="">
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {iconNavs, iconNavsSel} from 'common/js/icon-url'
import {getUploadParam, qiniuFormUpload} from 'api/api'
import {mapActions} from 'vuex'
export default {
    name: 'editIcon',
    data() {
        return {
            dialogFormVisible: false,
            way: '',
            iconData: [],
            selectedIconIndex: null,
            imgUrl: '',
            uploadSetting: {
                localvurl: '', // 本地访问图片地址
                uploadauth: '', // 授权信息
                uploadfilekey: '', // 文件保存名字
                uploadurl: '' // 上传文件地址
            },
            fileOtherInfo: {
                type: 'add',
                keyid: '',
                vsource: 1, // 1自己上传 2素材 3系统默认资源
                furl: ''
            },
            item: {
                barimgurl: '',
                barimgurlsel: ''
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            type: ''
        }
    },
    methods: {
        cancel() {
            this.dialogFormVisible = false
        },
        submit() {
            if (this.type === 'default') {
                this.item.barimgurl = this.imgUrl
            } else {
                this.item.barimgurlsel = this.imgUrl
            }
            this.cancel()
        },
        _getUploadParam(file) {            
            //20211027 获取文件后缀名
            let orginalfilename=file.name
            if(orginalfilename==''){
                this.$message.error("请选择正确的文件!");
                return
            }
            //给上传文件增加后缀名
            let fileSuffix=''
            let fileSuffixPos = orginalfilename.lastIndexOf(".");
            if(fileSuffixPos>=0){
                fileSuffix = orginalfilename.substring(fileSuffixPos,orginalfilename.length)
            }
            this.uploadType.filesuffix=fileSuffix

            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                    this.uploadFile(file)
                },
                error: data => {
                    this.$message.error('获取参数错误')
                    this.setLoading(false)
                }
            })
        },
        uploadFile(file) {
            let formData = new FormData()
            formData.append('file', file)
            formData.append('key', this.uploadSetting.uploadfilekey)
            formData.append('token', this.uploadSetting.uploadauth)
            qiniuFormUpload({
                url: this.uploadSetting.uploadurl,
                data: formData,
                success: (data) => {
                    if (this.type === 'default') {
                        this.item.barimgurl = this.fileOtherInfo.furl
                    } else {
                        this.item.barimgurlsel = this.fileOtherInfo.furl
                    }
                    this.cancel()
                },
                error: (data) => {
                    this.$message.error('上传失败，请重新上传')
                }
            })
        },
        uploadImg (e, num) {
            // 上传图片
            var file = e.target.files[0]
            if (!/\.(png|PNG)$/.test(e.target.value)) {
                this.$message.error('图片类型必须是.png')
                return false
            }
            this._getUploadParam(file)
        },
        choiceIcon(url, index) {
            this.imgUrl = url
            this.selectedIconIndex = index
        },
        openDialog(obj, type) {
            this.dialogFormVisible = true
            this.type = type
            if (this.type === 'default') {
                this.iconData = iconNavs()
            } else {
                this.iconData = iconNavsSel()
            }
            this.item = obj
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {}
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .editIcon{
        .localChoice{
            font-weight: 400;
            font-size: 14px;
        }
        .btnBox{
            display: flex;
            align-items: center;
            margin-top: 18px;
            .el-button{
                margin-bottom: 0;
            }
            .iconTips{
                color: #909399;
                margin-left: 14px;
            }
        }
        .iconLibrary{
            margin-top: 24px;
            .iconBox{
                display: flex;
                flex-wrap: wrap;
                margin-top: 15px;
                .iconItem{
                    width: 90px;
                    height: 90px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #DCDFE6;
                    box-sizing: border-box;
                    margin-bottom: 15px;
                    margin-right: 15px;
                    cursor: pointer;
                    img{
                        width: 30px;
                        height: 30px;
                    }
                }
                .select{
                    border: 1px solid #409EFF;
                }
            }
        }
    }
</style>
